import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import TopBarThemed from '../../components/top-bar-themed';
import useFaqServiceSupportHook from './faq-service-support.hook';
import * as styled from './faq-service-support.styles';
import themes from './themes';

export interface FaqServiceSupportProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = FaqServiceSupportProps & ThemeOverride;

function FaqServiceSupport(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t, superUserRole } = useFaqServiceSupportHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.FaqServiceSupport className={`faq-service-support ${className ?? ''}`.trim()} style={style}>
        <TopBarThemed topHeading={t("service-support")} />

        <div style={{display: 'flex', flexDirection: 'column',margin: '5vh 4vh 0 4vh', flex: '1', backgroundColor: '#cccccc99' }}>
          <iframe
            src={superUserRole === 'Ts-admin' ? 'UserManual-admin.pdf' : 'UserManual-operator.pdf'}
            title="PDF"
            style={{ height: "79vh", width: "100%" }}
          />
        </div>

      </styled.FaqServiceSupport>
    </ThemeProvider>
  );
}

export default memo(FaqServiceSupport) as unknown as typeof FaqServiceSupport;
